/**
 * created by lzy
 * 新闻日历管理
 */
'use strict';
angular.module('newsCalendarManagementModule', ['newsCalendarManagementRouterModule', 'newsCalendarManagementServiceModule']).controller('newsCalendarManagementCtrl', ['$scope', 'trsHttpService', 'dateReminderService', 'newsCalendarManagementService', '$sessionStorage', 'modalDialog', 'trsspliceString',
    function($scope, trsHttpService, dateReminderService, newsCalendarManagementService, $sessionStorage, modalDialog, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.status = {
                copyCurrPage: 1,
            };
            $scope.data = {
                items: [],
                selectedArray: [],
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 20,
                fromdate: '',
                untildate: '',
            };
            $scope.params = {};
        }

        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
            getUserInfo();
            requestData();
        }

        /**
         * [requestData description] 获取列表数据
         *
         * @return  {[type]}   [return description]
         */
        function requestData() {
            var params = {
                method: 'list',
                pageNum: $scope.page.CURRPAGE,
                pageSize: $scope.page.PAGESIZE,
                serviceid: 'daily',
                tenantId: $scope.data.curUserInfo.TENANTID,
                type: 4,
                userId: $scope.data.curUserInfo.ID,
                sortColumn: 'startTime',
            };
            params = angular.extend(params, $scope.params);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'get').then(function(data) {
                $scope.data.items = data.datas;
                $scope.data.selectedArray = [];
                $scope.page = {
                    CURRPAGE: data.summary_info.pageNum,
                    PAGESIZE: data.summary_info.pageSize,
                    ITEMCOUNT: data.summary_info.total,
                };
            });
        }

        /**
         * [getUserInfo description] 获取当前用户信息
         *
         * @return  {[type]}  [return description]
         */
        function getUserInfo() {
            $scope.data.curUserInfo = $sessionStorage.get('curUserInfo');
        }

        /**
         * [bulkImport description] 批量导入
         *
         * @return  {[type]}   [return description]
         */
        $scope.bulkImport = function() {
            newsCalendarManagementService.bulkImport().then((data) => {
                if (data.datas.importVOS.length) {
                    newsCalendarManagementService.calendarImportPrompt(data).then((data) => {
                        newsCalendarManagementService.resultPrompt(data).then((data) => {
                            if (data.saved_num) {
                                $scope.data.selectedArray = [];
                                requestData();
                            }
                        });
                    });
                } else {
                    newsCalendarManagementService.saveExcelResult({excelImportKey: data.datas.excelImportKey}).then((result) => {
                        result.datas.excelImportKey = data.datas.excelImportKey;
                        newsCalendarManagementService.resultPrompt(result.datas).then((data) => {
                            if (data.saved_num) {
                                $scope.data.selectedArray = [];
                                requestData();
                            }
                        });
                    })
                }
            });
        };

        /**
         * [createOrEdit description] 新建或编辑新闻日历
         *
         * @param  {[type]}  option   [option description]
         *
         * @return  {[type]}   [return description]
         */
        $scope.createOrEdit = function(option) {
            dateReminderService.createNewSchedule($scope.data.curUserInfo, option).then(function() {
                $scope.data.selectedArray = [];
                requestData();
            });
        };

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key) {
            $scope.params[key] = $scope.data.fromdate + ',' + $scope.data.untildate;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            requestData();
        };

        /**
         * [fullTextSearch description;全文检索]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.fullTextSearch = function(ev) {
            $scope.params.content = $scope.keywords;
            if ((angular.isDefined(ev) && ev.keyCode === 13) || angular.isUndefined(ev)) {
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        // 全选
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };
        // 单选
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        // 单个删除
        $scope.shanchuSingle = function(item) {
            modalDialog.confirmModal('删除', '确认删除该新闻日历?', function() {
                var params = {
                    method: 'delete',
                    serviceid: 'daily',
                    id: item.id,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        requestData();
                    });
                });
            });
        };
        // 批量删除
        $scope.plShanchu = function() {
            modalDialog.confirmModal('删除', '确认批量删除新闻日历?', function() {
                var params = {
                    method: 'batchdelte',
                    serviceid: 'daily',
                    ids: trsspliceString.spliceString($scope.data.selectedArray, 'id', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        requestData();
                    });
                });
            });
        };
    },
]);
